// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Invitation__wrapper___1_TrC","error":"Invitation__error___2bZzz","invitation":"Invitation__invitation___3_erL","logoWrapper":"Invitation__logoWrapper___1qe7X","logo":"Invitation__logo___38Ld7"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Invitation/components/Invitation.scss
// module id = 1212
// module chunks = 1